<div class="consultation-summary-layout">
  <aside class="summary-left-pane">
    <div class="pane-header">
      <h3>Classifications</h3>
      <span class="item-count">{{ summaryItems.length }}</span>
    </div>

    @if (isContextLoading) {
      <div class="pane-state">
        <mat-spinner diameter="28"></mat-spinner>
        <p>Loading Classifications...</p>
      </div>
    } @else if (summaryItems.length === 0) {
      <div class="pane-state empty">No classifications found.</div>
    } @else {
      <div class="source-list">
        @for (item of summaryItems; track trackBySummaryItem($index, item)) {
          <div class="source-item" [class.classification-item]="item.kind === 'classification'" [class.condition-item]="item.kind === 'condition'">
            <div class="source-item-row" [matTooltip]="getItemTooltip(item)" matTooltipPosition="above">
              <span class="source-item-main">{{ item.name }}</span>
              <div class="source-item-meta">
                @if (item.subText) {
                <span class="source-subtext">{{ item.subText }}</span>
                }
                <span class="source-status" [class.status-active]="item.status.toLowerCase() === 'active'" [class.status-inactive]="item.status.toLowerCase() === 'inactive'">{{ item.status | titlecase }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </aside>

  <section class="summary-right-pane">
    <div class="pane-header">
      <h3>Patient Summary</h3>
    </div>

    @if (lastGeneratedAt) {
      <div class="generated-at">Generated: {{ lastGeneratedAt | date:'dd MMM yyyy, hh:mm a' }}</div>
    }

    @if (isSummaryLoading) {
      <div class="pane-state">
        <mat-spinner diameter="30"></mat-spinner>
        <p>Generating patient summary...</p>
      </div>
    } @else if (summaryError) {
      <div class="pane-state error">
        {{ summaryError }}
      </div>
    } @else {
      <div class="summary-sections">
        @for (section of summarySections; track trackBySection($index, section)) {
          <article class="summary-section-card">
            <h4>{{ section.title }}</h4>
            <ul>
              @for (line of section.lines; track $index) {
                <li>{{ line }}</li>
              }
            </ul>
          </article>
        }
      </div>
    }
  </section>
</div>